import './components'
import './directives'

import { Injector } from '@/config/dependency-injection'
import { MetaService } from '@/shared/services/meta-service'
import { SharedModule } from '@/shared/store/shared-module'
import { getModule } from 'vuex-module-decorators'
import { onBootstrap } from '@/bootstrap'
import { StorageService } from '@/shared/utils/storage-service'
import { TokenHolder } from '@/shared/utils/token-holder'
import { TranslateService } from '@/shared/services/translate-service'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { AdminTokenHolder, AppToken } from '@/config/injection-tokens'
import { DevelopmentService } from '@/shared/development/development-service'
import { ResourceDialogDataSource } from '@/shared/components/resource-dialog/resource-dialog-data-source'
import { DragAndDropService } from '@/shared/services/drop-file/drag-and-drop-service'
import Vue from 'vue'

onBootstrap.add(({ store }) => {
  Injector.bindSingleton(DevelopmentService)
  Injector.bindSingleton(DragAndDropService)
  Injector.bindSingleton(MetaService)
  Injector.bindSingleton(ResourceDialogDataSource)
  Injector.bindSingleton(StorageService)
  Injector.bindSingleton(TokenHolder)
  Injector.bindSingleton(TranslateService)

  Injector.bindConstant(AdminTokenHolder, new TokenHolder('admin_token'))

  Injector.bindLazy(LoaderHelper, () => {
    const app = Injector.get<Vue>(AppToken)

    return new LoaderHelper(app)
  })

  Injector.bindLazy(SharedModule, () => {
    store.registerModule(SharedModule.STORE_NAME, SharedModule)

    return getModule<SharedModule>(SharedModule, store)
  })
})
